import styled from 'styled-components'
import { CssUnit } from '@/types'
import { toUnit } from '@/utils/styles'

interface Props {
  maxWidth?: CssUnit
  width?: CssUnit
  centerText?: boolean
  centerChildren?: boolean
  top?: CssUnit
  bottom?: CssUnit
  children: React.ReactNode
  className?: string
}

const CenterComponent = styled.div<{
  maxWidth: CssUnit
  $width: CssUnit
  centerText: boolean
  centerChildren: boolean
  top: CssUnit
  bottom: CssUnit
}>`
  margin: 0 auto;
  margin-top: ${({ top }) => toUnit(top)};
  margin-bottom: ${({ bottom }) => toUnit(bottom)};
  max-width: ${({ maxWidth }) => toUnit(maxWidth)};
  width: ${({ $width }) => toUnit($width)};
  ${({ centerText }) => centerText && `text-align: center;`}
  ${({ centerChildren }) =>
    centerChildren &&
    `
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`

const Center: React.FC<Props> = ({
  maxWidth = 'unset',
  width = 'auto',
  centerText = false,
  centerChildren = false,
  top = 0,
  bottom = 0,
  children,
  className
}) => {
  return (
    <CenterComponent
      maxWidth={maxWidth}
      $width={width}
      centerText={centerText}
      centerChildren={centerChildren}
      top={top}
      bottom={bottom}
      className={className}
    >
      {children}
    </CenterComponent>
  )
}

export default Center
